
<div class="flow-slideout">
	<div class="slideout-header">
		<!-- @slot Used to display slideout header -->
		<slot name="header" />
	</div>
	<div class="slideout-body">
		<!-- @slot Used to display slideout content -->
		<slot />
	</div>
	<div v-if="$slots.footer" class="slideout-footer">
		<!-- @slot Used to display optional slideout footer. -->
		<slot name="footer" />
	</div>
</div>
